export default "__VITE_ASSET__DmHj0Bk___"